module.exports = __webpack_public_path__ + "img/close_button_shop.fddb33d2.png";